// Network utilities for offline functionality
class NetworkUtils {
  constructor() {
    this.connectionChecked = false;
    this.isOnlineCache = navigator.onLine;
    this.setupEventListeners();
  }

  setupEventListeners() {
    window.addEventListener('online', () => {
      this.isOnlineCache = true;
      this.connectionChecked = true;
    });

    window.addEventListener('offline', () => {
      this.isOnlineCache = false;
      this.connectionChecked = true;
    });
  }

  // Check if we have internet connectivity
  async isConnected(forceCheck = false) {
    // If we haven't checked yet or force check is requested
    if (!this.connectionChecked || forceCheck) {
      if (!navigator.onLine) {
        this.isOnlineCache = false;
        this.connectionChecked = true;
        return false;
      }

      try {
        // Try to make a quick request to check connectivity
        // Use a generic endpoint or the base API URL if available
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3000);

        // We'll trust navigator.onLine mostly, but try a quick HEAD if we really want to be sure
        // For now, let's just use navigator.onLine as it's more reliable than a potentially missing health check
        this.isOnlineCache = true;
        this.connectionChecked = true;
        return true;
      } catch (error) {
        this.isOnlineCache = navigator.onLine;
        this.connectionChecked = true;
        return navigator.onLine;
      }
    }

    return navigator.onLine; // Always check fresh navigator status
  }

  // Quick check without network request
  isOnline() {
    return navigator.onLine;
  }

  // Check if we're offline
  isOffline() {
    return !navigator.onLine;
  }

  // Reset connection check (useful for testing)
  resetConnectionCheck() {
    this.connectionChecked = false;
  }

  // Get connection status with details
  getConnectionStatus() {
    return {
      online: navigator.onLine,
      lastChecked: this.connectionChecked,
      cached: this.isOnlineCache
    };
  }
}

const networkUtils = new NetworkUtils();
export default networkUtils;
